import { Drawer } from "antd";
import styled from "styled-components";
export const DrawerSauces = styled(Drawer)`
`;
